// extracted by mini-css-extract-plugin
export default {"listItem":"TermsConditions_listItem__dpG2H","HeadText":"TermsConditions_HeadText__29LIq"};